import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function ComingSoon({ titleEn, titleAr, titleTr, descriptionEn, descriptionAr, descriptionTr }) {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  const navigate = useNavigate();

  const displayTitle = i18n.language === 'tr' && titleTr ? titleTr : isRTL ? titleAr : titleEn;
  const displayDesc = i18n.language === 'tr'
    ? (descriptionTr || 'Size en iyi deneyimi sunmak için şu anda bu özelliği geliştiriyoruz. Yakında kullanıma sunulacak!')
    : isRTL 
    ? (descriptionAr || 'نعمل حالياً على تطوير هذه الميزة لتوفير أفضل تجربة لك. ستكون متاحة قريباً!')
    : (descriptionEn || 'We are currently developing this feature to provide you with the best experience. It will be available soon!');

  return (
    <>
      <Helmet>
        <title>{displayTitle ? `${displayTitle} - Coming Soon | CVLogs` : 'Coming Soon | CVLogs'}</title>
        <html lang={isRTL ? 'ar' : 'en'} dir={isRTL ? 'rtl' : 'ltr'} />
      </Helmet>

      <div className={`min-h-[80vh] flex flex-col items-center justify-center p-6 bg-[#FAFAFA] ${isRTL ? 'rtl' : 'ltr'}`} dir={isRTL ? 'rtl' : 'ltr'}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white rounded-3xl p-10 md:p-16 max-w-2xl w-full text-center border border-[#E5E7EB] shadow-sm"
        >
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-blue-50 text-[#2F80ED] text-sm font-bold mb-6">
            {i18n.language === 'tr' ? 'Yakında' : isRTL ? 'قريباً' : 'Coming Soon'}
          </div>

          <h1 className="text-3xl md:text-4xl font-bold text-[#333333] mb-4">
            {displayTitle || (i18n.language === 'tr' ? 'Yeni Özellik' : isRTL ? 'ميزة جديدة' : 'New Feature')}
          </h1>

          <p className="text-[#6B7280] mb-10 max-w-md mx-auto text-lg leading-relaxed">
            {displayDesc}
          </p>

          <button
            onClick={() => navigate('/dashboard')}
            className="inline-flex items-center justify-center gap-2 bg-[#2F80ED] text-white px-8 py-3 rounded-xl font-medium hover:bg-blue-700 transition-colors shadow-sm hover:shadow-md"
          >
            {i18n.language === 'tr' ? 'Kontrol Paneline Dön' : isRTL ? 'العودة للوحة التحكم' : 'Back to Dashboard'}
            <ArrowRight className={`w-5 h-5 ${isRTL ? 'rotate-180' : ''}`} />
          </button>
        </motion.div>
      </div>
    </>
  );
}
